import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Icon, Button } from 'antd';
import SingleActivityForm from 'components/form/SingleActivityForm.jsx';
import { aoObjectOf } from 'util/ArrayUtils.jsx';

class SingleSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isValid: false,
    };
  }

  componentWillUnmount() {
    this.setState = {
      isOpen: false,
      isValid: false,
    };
  }

  openDrawer = () => {
    this.setState({
      isOpen: true,
    });
  }

  closeDrawer = () => {
    this.setState({
      isOpen: false,
    });
  }

  checkValidity = (status) => {
    this.setState({
      isValid: status,
    });
  }

  handleSubmit = (values) => {
    const sendToWS = [];
    const activity = {
      data: null,
      durata: 0.0,
      aula: null,
      sede: null,
      idFormaDid: null,
      argomento: '',
      modalita: null,
      stato: 'N',
    };
    console.warn(values);
    activity.argomento = values.argomento;
    activity.data = values.date.hour(values.startTime.hour()).minutes(values.startTime.minutes());
    activity.durata = values.durata;
    activity.sede = values.sede;
    activity.aula = values.aula;
    activity.idFormaDid = values.formaDid;
    activity.modalita = values.modalita;
    const formaDid = aoObjectOf(this.props.formeDidScheduled,
                                parseInt(activity.idFormaDid, 10),
                                'idFormaDidattica');
    activity.descFormaDid = formaDid.descrizione;
    activity.stato = 'N';
    sendToWS.push(activity);
    console.warn('ecco cosa passo al ws:', sendToWS);
    this.props.onSaveClick(this.props.registryInfo.idRegistro, sendToWS);
  }

  render() {
    // const divClass = (this.props.centered ? 'row-buttons' : 'row-buttons float-left');
    return (
      <div style={{ marginRight: '10px', float: 'left' }}>
        <Button type="primary" size="large" onClick={this.openDrawer}>
          <Icon type="schedule" />Attività Singola
        </Button>
        <Drawer
          title="Inserisci nuova attività"
          visible={this.state.isOpen}
          placement="left"
          width="40%"
          maskClosable={false}
          onClose={this.closeDrawer}
        >
          <SingleActivityForm
            registryInfo={this.props.registryInfo}
            formeDidScheduled={this.props.formeDidScheduled}
            onSubmit={this.handleSubmit}
            onCancel={this.closeDrawer}
          />
        </Drawer>
      </div>
    );
  }

}

SingleSchedule.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  // registryId: PropTypes.number.isRequired,
  // registryYear: PropTypes.number.isRequired,
  // registryCDL: PropTypes.string.isRequired,
  formeDidScheduled: PropTypes.arrayOf(PropTypes.object),
  onSaveClick: PropTypes.func.isRequired,
  centered: PropTypes.bool,
};

export default SingleSchedule;
